/**
 * Normalize API color strings for CSS.
 * Admin sometimes stores hex without `#` (e.g. `050f27`) — then `color-mix()`
 * and solid backgrounds fail silently (no border, no pulse rings).
 */
export function normalizeCssColor(
  value: string | null | undefined,
): string | null {
  if (value == null) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (
    trimmed.startsWith('#') ||
    trimmed.startsWith('rgb') ||
    trimmed.startsWith('hsl') ||
    trimmed.startsWith('color(') ||
    trimmed.startsWith('color-mix(') ||
    trimmed.startsWith('var(')
  ) {
    return trimmed;
  }

  // Bare hex: 3 / 6 / 8 digits
  if (/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$|^[0-9a-fA-F]{8}$/.test(trimmed)) {
    return `#${trimmed}`;
  }

  // Named colors / other keywords (white, transparent, currentColor, …)
  return trimmed;
}

/** Like {@link normalizeCssColor}, but keeps a fallback when input is empty. */
export function normalizeCssColorOr(
  value: string | null | undefined,
  fallback: string,
): string {
  return normalizeCssColor(value) ?? fallback;
}
